var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259.53,
    height: 259.52,
    viewBox: "0 0 259.53 259.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.9,44.28h20.27V64.56c4,0,7.62,0,11.24,0,18.12.06,31.33,13.23,31.33,31.36q0,88.3,0,176.61a33.87,33.87,0,0,1-.77,7.52c-3.34,14.42-15.39,23.74-30.62,23.75H87.7c-.68,0-1.35,0-2,0a30.3,30.3,0,0,1-23.26-12.06c-3.43-4.35-5-9.46-6.18-14.77V91.42a5.34,5.34,0,0,0,.38-.93c3.61-16.76,14.93-25.93,32-25.93H98.81V44.28h20.27V64.4H252.9ZM76.51,139.68v131.8c0,8.22,3.84,12,12.1,12H283.48c8.1,0,12-3.86,12-11.91V139.68ZM253,85H119V105H98.72V84.83c-4.08,0-7.87,0-11.66,0-6.27.1-10.47,4.28-10.54,10.56-.06,6,0,12,0,18v5.73H295.44c0-8.36.12-16.55-.05-24.73A9.48,9.48,0,0,0,287,85.06c-4.49-.41-9.05-.09-13.85-.09v20H253Z",
    transform: "translate(-56.23 -44.28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.9,161V181h-20V161Z",
    transform: "translate(-56.23 -44.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.43,181H135.5V161h19.93Z",
    transform: "translate(-56.23 -44.28)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176,181V161h20v20Z",
    transform: "translate(-56.23 -44.28)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5,180.94V161h20.05v19.92Z",
    transform: "translate(-56.23 -44.28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.05,181V161h20v20Z",
    transform: "translate(-56.23 -44.28)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.85,221.58h-20v-20h20Z",
    transform: "translate(-56.23 -44.28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.47,201.6v20h-20v-20Z",
    transform: "translate(-56.23 -44.28)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176,201.53h20v20H176Z",
    transform: "translate(-56.23 -44.28)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M216.59,201.51h19.94v20.06H216.59Z",
    transform: "translate(-56.23 -44.28)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M257.12,201.54h20v20h-20Z",
    transform: "translate(-56.23 -44.28)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.86,262.05V242.11h20v19.94Z",
    transform: "translate(-56.23 -44.28)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.49,242.07h19.95v20H135.49Z",
    transform: "translate(-56.23 -44.28)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196,262.13H176v-20h20Z",
    transform: "translate(-56.23 -44.28)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.62,242h19.87v20H216.62Z",
    transform: "translate(-56.23 -44.28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.5e0861ab21ddbd763843cdfe5bb46160.svg";
export { ForwardRef as ReactComponent };